import { useTranslation } from 'react-i18next'

import { Heading, Subtitle } from '../../../components/typography'
import FullWidthPage from '../../../components/layout/FullWidthPage'
import { PageContent } from '../../../components/Container'
import { useCurrentMove } from '../../../modules/moves'

const MoveNoQuotesPage: React.FC = () => {
  const { t } = useTranslation()
  const move = useCurrentMove()

  return (
    <FullWidthPage>
      <PageContent>

        <div className="pt-4 text-center">

          <Heading variant="h1">
            { t('pages.move.noQuotes.title', {
              firstName: move.customer.firstName,
            }) }
          </Heading>
          <Subtitle className="my-12 lg:text-center">
            { t('pages.move.noQuotes.line1') }
            <br />
            { t('pages.move.noQuotes.line2') }
            <br />
            { t('pages.move.noQuotes.line3') }
          </Subtitle>

        </div>

      </PageContent>
    </FullWidthPage>
  )
}

export default MoveNoQuotesPage
